export default __webpack_public_path__ + "static/media/Hyper.c305d56b.jpg";